module.exports = __webpack_public_path__ + "img/x-lotto99-icon.c515e563.png";